import React from 'react';
import { Stack, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { ICellRendererParams } from 'ag-grid-community';
import { getUserProfileFullName } from '../../utils/users';
import UserAvatar from '../../sections/users/UserAvatar';
import CustomTooltip from 'components/CustomTooltip';

interface UserCellRendererProps {
  data: ICellRendererParams['data'] | null;
  spacing?: number;
  pt?: number;
  sx?: SxProps;
  showBadge?: boolean;
  showRole?: boolean;
  showEmail?: boolean;
  useCompactViewStyle?: boolean | null;
}

const UserCellRenderer: React.FC<UserCellRendererProps> = ({
  data,
  spacing = 1.5,
  pt = 0.5,
  sx = {},
  showBadge = true,
  showRole = true,
  showEmail = false,
  useCompactViewStyle = false
}) => {
  if (!data) return null;
  const nameTypography = (
    <Typography variant="subtitle1" sx={{ fontSize: useCompactViewStyle ? 11 : 13, fontWeight: 400 }}>
      {getUserProfileFullName(data)}
    </Typography>
  );
  const userFullNameSection =
    showEmail ? <CustomTooltip title={data?.email}>{nameTypography}</CustomTooltip> : nameTypography;
  return (
    <Stack direction="row" spacing={spacing} sx={{ pt, ...sx }} alignItems="center" >
      <UserAvatar user={data} showBadge={showBadge} useCompactViewStyle={useCompactViewStyle} />
      <Stack spacing={0}>
        {userFullNameSection}
        {showRole && (
          <Typography variant="caption" color="textSecondary">
            {data.role?.join(' / ')}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default UserCellRenderer;
